/**
 * "Trova il prodotto adatto a te" — quiz engine.
 *
 * Reads two JSON blobs rendered by sections/product-quiz.liquid: the product
 * taxonomy and the question/answer blocks. Liquid cannot group a flat block
 * list into nested questions, so that grouping happens here: a "domanda" block
 * opens a question and every "risposta" after it belongs to it.
 *
 * Matching: area is a hard filter, esigenza and pelle score. A product marked
 * "tutti i tipi" scores on any skin type, but below an exact match, so a
 * product formulated for dry skin outranks a general one for a dry-skin answer.
 */
(function () {
  'use strict';

  var SCORE = { esigenza: 3, pelle: 2, pelleGeneric: 1 };
  var SMALL_AREA_MAX = 3;   // at or below this, skip the questions and show the range
  var GENERIC_SKIN = 'tutti i tipi';

  function parseJSON(el) {
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }


  /**
   * Default questions, used when the section has no "domanda" blocks.
   *
   * A section rendered statically by {% section %} does not receive its
   * preset's blocks, so without these the quiz would do nothing until someone
   * hand-built twenty-odd blocks in the theme editor. Adding any question
   * block in the customizer replaces this set entirely.
   *
   * The skin question is worded as symptoms rather than categories: most
   * people cannot classify their own skin, and asking them to is where
   * quizzes lose people. "Non saprei" is a real, unpenalised answer.
   */
  var DEFAULTS = [
    { text: 'Di cosa ti vuoi prendere cura?', field: 'area', max: 1, skipForArea: '',
      answers: [
        { label: 'Viso', value: 'viso' },
        { label: 'Corpo', value: 'corpo' },
        { label: 'Contorno occhi', value: 'contorno occhi' },
        { label: 'Labbra', value: 'labbra' },
        { label: 'Capelli', value: 'capelli' },
        { label: 'Mani', value: 'mani' },
        { label: 'Barba', value: 'barba' }
      ] },
    { text: "Com'è la tua pelle, di solito?", field: 'pelle', max: 1, skipForArea: 'capelli',
      hint: 'Scegli la descrizione che ti somiglia di più.',
      answers: [
        { label: 'Tira dopo la detersione', value: 'secca', note: 'Sensazione di pelle che tira, a volte desquama' },
        { label: 'Molto secca e screpolata', value: 'molto secca', note: 'Ruvida al tatto, si screpola facilmente' },
        { label: 'Si arrossa facilmente', value: 'sensibile', note: 'Reagisce a prodotti nuovi, freddo, vento' },
        { label: 'Lucida sulla zona T', value: 'mista', note: 'Fronte e naso lucidi, guance normali' },
        { label: 'Ha perso tono ed elasticità', value: 'matura' },
        { label: 'Normale, nessun fastidio', value: 'normale' },
        { label: 'Non saprei', value: '' }
      ] },
    // Every esigenza value the catalogue actually uses, not just the eight
    // that suited the face. usableAnswers() cuts this down to the ones the
    // chosen area really has, so a long list here costs the customer nothing
    // and stops the quiz from offering needs Note di Sapone cannot meet.
    { text: 'Cosa vorresti migliorare?', field: 'esigenza', max: 2,
      hint: 'Puoi scegliere fino a due risposte.',
      answers: [
        { label: 'Idratare', value: 'idratazione' },
        { label: 'Nutrire in profondità', value: 'nutriente' },
        { label: 'Detergere', value: 'detersione' },
        { label: 'Struccare', value: 'struccante' },
        { label: 'Contrastare i segni del tempo', value: 'anti-età' },
        { label: 'Rassodare', value: 'rassodante' },
        { label: 'Tonificare', value: 'tonificante' },
        { label: 'Lenire e calmare', value: 'lenitiva' },
        { label: 'Purificare', value: 'purificante' },
        { label: 'Esfoliare', value: 'esfoliante' },
        { label: 'Illuminare', value: 'illuminante' },
        { label: 'Drenare', value: 'drenante' },
        { label: 'Attenuare le occhiaie', value: 'anti occhiaie' },
        { label: 'Ridurre le borse', value: 'anti borse' },
        { label: 'Districare', value: 'districante' },
        { label: 'Rinforzare', value: 'rinforzante' }
      ] }
  ];

  function build(root) {
    var start = root.querySelector('[data-quiz-start]');
    var products = parseJSON(root.querySelector('[data-quiz-products]')) || [];
    var config = parseJSON(root.querySelector('[data-quiz-config]'));

    // A dead button with no explanation is the worst failure mode here, so say
    // what is wrong instead of returning silently.
    if (!start) return;
    if (!config || !products.length) {
      start.addEventListener('click', function () {
        root.querySelector('[data-quiz-stage]').hidden = false;
        root.querySelector('[data-quiz-stage]').textContent =
          'Il quiz non trova i prodotti. Controlla che i metacampi Area, Pelle ed Esigenza siano compilati.';
      });
      return;
    }

    // group the flat block list into questions
    var questions = [];
    config.blocks.forEach(function (b) {
      if (b.type === 'domanda') {
        questions.push({
          text: b.question, hint: b.hint, field: b.field,
          max: Math.max(1, parseInt(b.max, 10) || 1),
          skipForArea: b.skipForArea, answers: []
        });
      } else if (b.type === 'risposta' && questions.length) {
        questions[questions.length - 1].answers.push({
          label: b.label, value: b.value, note: b.note
        });
      }
    });
    if (!questions.length) questions = DEFAULTS.slice();

    var intro = root.querySelector('[data-quiz-intro]');
    var stage = root.querySelector('[data-quiz-stage]');
    var wanted = parseInt(root.getAttribute('data-quiz-results'), 10) || 3;

    var answers = {};   // field -> [values]
    var path = [];      // indexes of the questions actually shown
    var at = 0;

    function poolForArea() {
      var area = (answers.area || [])[0];
      if (!area) return products;
      return products.filter(function (p) { return p.area === area; });
    }

    /** every non-empty value of `field` across a set of products */
    function valuesIn(pool, field) {
      var seen = {};
      pool.forEach(function (p) {
        var v = p[field];
        if (v == null) return;
        if (typeof v === 'string') { if (v) seen[v] = true; return; }
        v.forEach(function (x) { if (x) seen[x] = true; });
      });
      return seen;
    }

    /**
     * The answers worth showing for this question given the area already
     * chosen. This is what removes the dead ends: before it, question 3
     * offered the same eight needs for every area, so "Mani + Esfoliare" and
     * 27 other combinations led to a screen with no products on it. An answer
     * with an empty value ("Non saprei") is never filtered out -- it is a way
     * of declining the question, not a claim about the catalogue.
     */
    function usableAnswers(q, pool) {
      if (q.field === 'area') return q.answers;
      var seen = valuesIn(pool, q.field);
      return q.answers.filter(function (a) { return !a.value || seen[a.value]; });
    }

    function realAnswerCount(q, pool) {
      return usableAnswers(q, pool).filter(function (a) { return a.value; }).length;
    }

    function activeQuestions() {
      var area = (answers.area || [])[0];
      var pool = poolForArea();

      // Mani has one product, Capelli two. Asking someone three questions to
      // arrive at a single jar reads as a quiz wasting their time, so once the
      // area is chosen and the shelf is this short, show the shelf.
      var small = area && pool.length > 0 && pool.length <= SMALL_AREA_MAX;

      return questions.filter(function (q) {
        if (q.field === 'area') return true;
        if (small) return false;
        if (q.skipForArea && area && q.skipForArea === area) return false;
        // a question with one usable answer left cannot narrow anything
        return realAnswerCount(q, pool) >= 2;
      });
    }

    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    }

    function renderQuestion() {
      var list = activeQuestions();
      if (at >= list.length) return renderResults();
      var q = list[at];

      stage.innerHTML = '';

      var bar = el('div', 'quiz__progress');
      var fill = el('span', 'quiz__progress-fill');
      fill.style.width = ((at) / list.length * 100) + '%';
      bar.appendChild(fill);
      stage.appendChild(bar);

      stage.appendChild(
        el('p', 'quiz__step',
          (config.stepLabel || '')
            .replace('[n]', at + 1)
            .replace('[tot]', list.length))
      );

      var fs = el('fieldset', 'quiz__question');
      fs.appendChild(el('legend', 'quiz__legend', q.text));
      if (q.hint) fs.appendChild(el('p', 'quiz__hint', q.hint));

      var opts = el('div', 'quiz__options');
      var chosen = (answers[q.field] || []).slice();

      usableAnswers(q, poolForArea()).forEach(function (a) {
        var btn = el('button', 'quiz__option');
        btn.type = 'button';
        btn.setAttribute('aria-pressed', chosen.indexOf(a.value) > -1 ? 'true' : 'false');
        btn.appendChild(el('span', 'quiz__option-label', a.label));
        if (a.note) btn.appendChild(el('span', 'quiz__option-note', a.note));

        btn.addEventListener('click', function () {
          var i = chosen.indexOf(a.value);
          if (i > -1) {
            chosen.splice(i, 1);
          } else {
            if (q.max === 1) chosen.length = 0;
            else if (chosen.length >= q.max) return;
            chosen.push(a.value);
          }
          answers[q.field] = chosen.slice();
          if (q.max === 1) { advance(); return; }
          renderQuestion();
        });
        opts.appendChild(btn);
      });
      fs.appendChild(opts);
      stage.appendChild(fs);

      var nav = el('div', 'quiz__nav');
      if (at > 0) {
        var back = el('button', 'quiz__nav-btn', config.backLabel);
        back.type = 'button';
        back.addEventListener('click', function () { at = Math.max(0, at - 1); renderQuestion(); });
        nav.appendChild(back);
      }
      if (q.max > 1) {
        var next = el('button', 'btn quiz__nav-next', config.nextLabel);
        next.type = 'button';
        next.disabled = !chosen.length;
        next.addEventListener('click', advance);
        nav.appendChild(next);
      }
      stage.appendChild(nav);

      var first = opts.querySelector('.quiz__option');
      if (first) first.focus();
    }

    function advance() { at++; renderQuestion(); }

    function score(p) {
      var pts = 0, why = [];
      (answers.esigenza || []).forEach(function (v) {
        if (p.esigenza.indexOf(v) > -1) { pts += SCORE.esigenza; why.push(v); }
      });
      (answers.pelle || []).forEach(function (v) {
        if (p.pelle.indexOf(v) > -1) { pts += SCORE.pelle; why.push('pelle ' + v); }
        else if (p.pelle.indexOf(GENERIC_SKIN) > -1) { pts += SCORE.pelleGeneric; }
      });
      return { pts: pts, why: why };
    }

    /**
     * Collapsing interchangeable products into one card with a chooser.
     *
     * Two products this quiz scores identically are, as far as it can tell, the
     * same product. SCRUB CORPO Sale e Lavanda and SCRUB CORPO Zucchero e Caffe
     * carry the same area, esigenza and pelle, so whenever one is recommended
     * the other is too -- and "Aggiungi la routine al carrello" then quietly
     * puts two jars of the same scrub in the basket. The customer picked a
     * routine, not a duplicate.
     *
     * The test is deliberately two-part: the same uppercase name prefix AND the
     * same taxonomy. The prefix alone over-groups -- CREMA VISO Anti Eta and
     * CREMA VISO Anti-Age Notte share it but are a day cream and a night cream,
     * two things someone may well want both of -- and their taxonomies differ,
     * so they correctly stay two cards. Today this collapses exactly three
     * families: burro corpo (4 scents), sapone naturale (5), scrub corpo (2).
     */
    function familyKey(title) {
      var words = String(title || '').trim().split(/\s+/);
      var lead = [];
      for (var i = 0; i < words.length; i++) {
        // the first word carrying a lower-case letter ends the product type
        if (/[a-z\u00e0-\u00f6\u00f8-\u00ff]/.test(words[i])) break;
        lead.push(words[i]);
      }
      return lead.join(' ').toLowerCase();
    }

    function taxonomyKey(p) {
      function sorted(a) { return (a || []).slice().sort().join('|'); }
      return p.area + '~' + sorted(p.esigenza) + '~' + sorted(p.pelle);
    }

    /** "BURRO CORPO  Agrumi" -> "Agrumi" — what actually distinguishes it */
    function variantLabel(p) {
      var words = String(p.title || '').trim().split(/\s+/);
      var n = 0;
      while (n < words.length && !/[a-z\u00e0-\u00f6\u00f8-\u00ff]/.test(words[n])) n++;
      return words.slice(n).join(' ') || p.title;
    }

    function collapseFamilies(list) {
      var seen = {}, out = [];
      list.forEach(function (r) {
        var fam = familyKey(r.p.title);
        var key = fam ? fam + '##' + taxonomyKey(r.p) : '@' + r.p.handle;
        if (seen[key]) { seen[key].options.push(r.p); return; }
        seen[key] = { p: r.p, pts: r.pts, why: r.why, options: [r.p] };
        out.push(seen[key]);
      });
      return out;
    }

    function renderResults() {
      var pool = poolForArea();

      // True when the customer actually told us something to match on. It is
      // false in exactly two cases: a small area where the questions were
      // skipped, and someone who answered "Non saprei" to everything. Both
      // want the same thing -- the range for that area, not an empty screen.
      var hasInput = (answers.esigenza || []).some(Boolean) ||
                     (answers.pelle || []).some(Boolean);

      var ranked;
      if (!hasInput) {
        ranked = collapseFamilies(pool.slice().sort(function (a, b) {
          if (a.available !== b.available) return a.available ? -1 : 1;
          return 0;
        }).map(function (p) { return { p: p, pts: 0, why: [] }; }));
        ranked = ranked.slice(0, ranked.length <= SMALL_AREA_MAX ? ranked.length : wanted);
      } else {
        ranked = pool.map(function (p) {
          var s = score(p);
          return { p: p, pts: s.pts, why: s.why };
        }).filter(function (r) {
          // Only recommend what we can give a reason for. A product that merely
          // says "tutti i tipi" is not an answer to "ho la pelle grassa", and
          // showing it under "perché te lo consigliamo" with nothing to say
          // reads as padding. Better to return two good matches than three.
          return r.why.length > 0;
        }).sort(function (a, b) {
          if (b.pts !== a.pts) return b.pts - a.pts;
          if (a.p.available !== b.p.available) return a.p.available ? -1 : 1;
          return 0;
        });
        // collapse BEFORE taking the top three, so the three slots go to three
        // different products rather than three scents of the same one
        ranked = collapseFamilies(ranked).slice(0, wanted);
      }

      stage.innerHTML = '';
      stage.appendChild(el('h2', 'quiz__results-title', config.resultsTitle));

      if (!ranked.length) {
        stage.appendChild(el('p', 'quiz__lead', config.emptyText));
        appendContact(false);
        stage.appendChild(restartButton());
      } else {
        stage.appendChild(el('p', 'quiz__lead',
          hasInput ? config.resultsLead : (config.rangeLead || config.resultsLead)));

        var grid = el('div', 'quiz__results');
        // one entry per card, holding whichever product that card is currently
        // showing; "add the routine" reads these at click time, not at render,
        // so it always adds what the customer can actually see
        var picked = [];

        ranked.forEach(function (r) {
          var state = { p: r.p };
          picked.push(state);

          var card = el('article', 'quiz__card');
          var a = el('a', 'quiz__card-link');
          a.href = r.p.url;

          var img = null;
          if (r.p.image) {
            img = document.createElement('img');
            img.className = 'quiz__card-img';
            img.src = r.p.image;
            img.alt = r.p.title;
            img.loading = 'lazy';
            a.appendChild(img);
          }

          var title = el('h3', 'quiz__card-title', r.p.title);
          a.appendChild(title);
          card.appendChild(a);

          var price = el('p', 'quiz__card-price', r.p.price);
          card.appendChild(price);

          // The reason is deliberately NOT shown: repeating "idratazione, pelle
          // secca" under three cards restates the answers the customer just
          // gave. It is still computed, because score().why is what decides
          // whether a product is recommendable at all -- a product we can say
          // nothing about is not an answer to the question.

          var add = el('button', 'btn btn--secondary quiz__card-add', config.addOneLabel);
          add.type = 'button';

          function show(p) {
            state.p = p;
            title.textContent = p.title;
            price.textContent = p.price;
            a.href = p.url;
            if (img && p.image) { img.src = p.image; img.alt = p.title; }
            add.disabled = !p.available;
          }

          if (r.options.length > 1) {
            var choice = el('div', 'quiz__choice');
            if (config.chooseLabel) {
              var lbl = el('label', 'quiz__choice-label', config.chooseLabel);
              lbl.setAttribute('for', 'quiz-choice-' + picked.length);
              choice.appendChild(lbl);
            }
            var sel = document.createElement('select');
            sel.className = 'quiz__choice-select';
            sel.id = 'quiz-choice-' + picked.length;
            if (!config.chooseLabel) sel.setAttribute('aria-label', r.p.title);
            r.options.forEach(function (p, i) {
              var o = document.createElement('option');
              o.value = String(i);
              o.textContent = variantLabel(p) + (p.available ? '' : ' \u2014 ' + (config.soldOutLabel || 'esaurito'));
              sel.appendChild(o);
            });
            sel.addEventListener('change', function () {
              show(r.options[parseInt(sel.value, 10) || 0]);
            });
            choice.appendChild(sel);
            card.appendChild(choice);
          }

          show(r.p);
          add.addEventListener('click', function () { addToCart([state.p.variant], add); });
          card.appendChild(add);

          grid.appendChild(card);
        });
        stage.appendChild(grid);

        if (picked.filter(function (c) { return c.p.available; }).length > 1) {
          var all = el('button', 'btn quiz__add-all', config.addAllLabel);
          all.type = 'button';
          all.addEventListener('click', function () {
            var ids = picked.filter(function (c) { return c.p.available; })
                            .map(function (c) { return c.p.variant; });
            if (ids.length) addToCart(ids, all);
          });
          stage.appendChild(all);
        }

        // Someone who has just been handed a three-step routine by a machine
        // often has one question left -- why this cream and not that one. The
        // empty state has offered WhatsApp from the start; now that the quiz
        // has no dead ends that screen is almost never reached, and the
        // question is just as likely after a good answer as after no answer.
        // Restart sits directly under the routine it would discard; the
        // invitation to ask a question comes after, so the screen ends on an
        // offer of help rather than on a way to throw the answer away.
        stage.appendChild(restartButton());
        appendContact(true);
      }
    }

    /**
     * The invitation to ask a question, and the button that acts on it.
     *
     * api.whatsapp.com is the same address the floating bubble uses: it hands
     * off to the app on a phone and opens WhatsApp Web on a computer. The
     * web.whatsapp.com form this replaced showed phone users an "open this on a
     * computer" page, which is no use to someone who just took the quiz.
     *
     * Both go in one wrapper rather than being centred individually: a single
     * text-align on the parent centres the paragraph's text AND the button,
     * which is an inline-block, with no dependence on width: fit-content.
     */
    function appendContact(withHelp) {
      var help = withHelp && config.whatsappHelp;
      if (!config.whatsappUrl && !help) return;

      var box = el('div', 'quiz__contact');
      if (help) box.appendChild(el('p', 'quiz__help', config.whatsappHelp));

      if (config.whatsappUrl) {
        var wa = document.createElement('a');
        wa.className = 'btn quiz__whatsapp';
        wa.href = config.whatsappUrl;
        wa.target = '_blank';
        wa.rel = 'noopener';
        wa.textContent = config.whatsappLabel || 'WhatsApp';
        box.appendChild(wa);
      }
      stage.appendChild(box);
    }

    function restartButton() {
      var again = el('button', 'quiz__restart', config.restartLabel);
      again.type = 'button';
      again.addEventListener('click', function () {
        answers = {}; at = 0; renderQuestion();
      });
      return again;
    }

    function addToCart(ids, button) {
      var original = button.textContent;
      button.disabled = true;
      button.textContent = '…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
      })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () {
          button.disabled = false;
          button.textContent = original;
        });
    }

    start.addEventListener('click', function () {
      intro.hidden = true;
      stage.hidden = false;
      renderQuestion();
    });
    start.disabled = false;
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-quiz]'), function (r) {
      try { build(r); } catch (e) { /* never break the page */ }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
